import React from 'react';

import {
  EnabledContextActionsQueryOperationQuery as EnabledContextActionsQueryOperation,
  EntityListFragment,
} from 'core/graphql';
import { ContextActionMenuItems } from 'shared/components/internal/ContextAction/ContextActionMenuItems';
import { CONTEXT_ACTION_QUERY } from 'shared/components/internal/ContextAction/gql';
import {
  useIocMatches,
  useMatchedTypes,
} from 'shared/components/internal/ContextAction/utils';
import { ValueBasedFilterTypes } from 'shared/components/internal/Filter';
import { useQuery } from 'shared/hooks';

import { onQuickFilter } from './utils';

export interface EntityContextActionProps {
  entity: EntityListFragment;
  onQueryChange: (q: string) => void;
}

export const EntityContextActions = ({
  entity,
  onQueryChange,
}: EntityContextActionProps) => {
  const { value, entityType } = entity;

  const { data } =
    useQuery<EnabledContextActionsQueryOperation>(CONTEXT_ACTION_QUERY);

  const { contextActions, sumoLogicRegion } = data ?? {};
  const actions = contextActions?.objects ?? [];

  const matches = useIocMatches(value, [{ type: 'keyword' }]);

  const matchedTypes = useMatchedTypes({
    actions,
    entityType,
    matches,
  });

  const onFilter = (filter: ValueBasedFilterTypes) =>
    onQuickFilter(filter, onQueryChange);

  const onQuickFilterByEntityValue = (value: string, negated?: boolean) => {
    onFilter?.({
      operator: 'equals',
      prop: 'value',
      value,
      negated: negated ?? false,
    });
  };

  return (
    <ContextActionMenuItems
      contextData={entity}
      matchedContextActions={matchedTypes}
      matches={matches}
      sumoLogicRegion={sumoLogicRegion ?? undefined}
      value={value}
      onQuickFilter={onQuickFilterByEntityValue}
    />
  );
};
